var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 ma-auto"},[_c('apexchart',{ref:"realTimeBarChart",attrs:{"type":"bar","height":_vm.user.level != 1 ? 294 : 235,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }